import type { ChatStatus, DisplayStatus } from '../common/@types'
import { DISPLAY_STATUSES } from '../common/constants'
import { getLsItem, setLsItem } from './localStorage'

type WidgetStateProps = Partial<{
  displayStatus: DisplayStatus
  chatStatus: ChatStatus
}>

const setLsWidgetStatus = (id: string, value: WidgetStateProps) => {
  setLsItem<WidgetStateProps>(`state:${id}`, value)
}

const getLsWidgetState = (id: string) => {
  return getLsItem<WidgetStateProps>(`state:${id}`)
}

export default class WidgetState {
  private appId: string
  private state: WidgetStateProps

  constructor(appId: string, defaultState?: WidgetStateProps) {
    this.appId = appId
    const storedState = getLsWidgetState(appId)
    this.state = {
      ...storedState,
      displayStatus:
        defaultState?.displayStatus || storedState?.displayStatus || DISPLAY_STATUSES.Closed,
    }
  }

  get displayStatus() {
    return this.state.displayStatus
  }

  setDisplayStatus(displayStatus: DisplayStatus): void {
    setLsWidgetStatus(this.appId, {
      ...this.state,
      displayStatus,
    })
    this.state.displayStatus = displayStatus
  }

  get chatStatus() {
    return this.state.chatStatus
  }

  setChatStatus(chatStatus: ChatStatus): void {
    setLsWidgetStatus(this.appId, {
      ...this.state,
      chatStatus,
    })
    this.state.chatStatus = chatStatus
  }
}
